import React, { useMemo } from "react";
import { Flag } from "semantic-ui-react";

import Utility from "../Utility";

function useFormFormatedList(globalContext) {
  const data = useMemo(() => {
    const listIndicatifTel = Utility.getListTelephoneCode(globalContext);

    const listPaysSelect = []
    globalContext.countries.forEach(country => {
      if (Utility.testFlag(country.iso.toLowerCase())) {
        listPaysSelect.push({
          key: country.iso,
          text: [<Flag name={country.iso.toLowerCase()} key={country.id + 'Flag'} />, country.name], 
          value: country.iso 
        })
      }
    })

    const identityDocumentTypeSelect = globalContext.identityDocuments.map(document => ({
      key: document.id,
      text: document.name,
      value: document.id
    }));
  
    const languageSelect = globalContext.languages.map(languague => ({
      key: languague.id,
      text: [<Flag name={languague.iso.toLowerCase()} key={languague.iso + 'Flag'} />, languague.originalName],
      value: languague.iso
    }));
   
    return { listIndicatifTel, listPaysSelect, identityDocumentTypeSelect, languageSelect }

  }, [globalContext.countries, globalContext.identityDocuments, globalContext.languages])

  return data
}

export default useFormFormatedList